import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from "react-redux";

import AppContext from 'app/AppContext';
import TriviaProApi from 'api/TriviaPro';
import StoreWidget from './StoreWidget';
import EventsWidget from './EventsWidget';
import QuizWidget from './QuizWidget.js';

class Dashboard extends React.Component {
    state = {
        store: null,
    };

    async componentDidMount() {
        const response = await TriviaProApi.MyShops();

        if(response) {
            if(response.data.data && response.data.data.length > 0) {
                // AppContext.s['shop-id'] = response.data.data.id;

                this.setState({
                    store: response.data.data[0]
                });
            } else {
                this.setState({
                    store: -1
                });
            }
        }
    }

    render() {
        const { store } = this.state;
        const { user } = this.props.auth;

        if(!store || !user)
            return AppContext.r["preloader"];

        let map = "";

        if(store === -1) {
            map = <h3 className="text-center">{AppContext.r["no-role"]}</h3>
        } else if(store.active === 0) {
            map = <h3 className="text-center">{AppContext.r["shop-not-active"]}</h3>
        } else if(!user.roles[0]) {
            map = <h3 className="text-center">{AppContext.r["no-role"]}</h3>
        } else {
            const widgets = [];
    
            if(user.roles[0].id === 3) {
                widgets.push({
                    "name": "Store",
                    "status": { "collapsed": false },
                    "xl": 12
                });

                widgets.push({
                    "name": "Quiz",
                    "status": { "collapsed": false },
                    "xl": 12
                });
            }

            // Admin Dashboard
            if(user.roles[0].id === 1) {
                widgets.push({
                    "name": "Events",
                    "status": { "collapsed": false },
                    "sm": 12
                });
            }
            
            let i = 0;
            map = widgets.map(w => (
                <Col xl={w.xl} sm={12} key={i++}>
                    {w.name === "Store" && 
                        <StoreWidget className="store" collapsed={w.status.collapsed} 
                            store={store} onWidgetStatusChanged={this.onWidgetStatusChanged}/>}

                    {w.name === "Quiz" && 
                        <QuizWidget className="quiz" collapsed={w.status.collapsed} 
                            store={store} onWidgetStatusChanged={this.onWidgetStatusChanged}/>}

                    {w.name === "Events" && 
                        <EventsWidget store={store} disableInsert />}
                </Col>)
            );
        }
        
        return (
            <div className="home iq-dashboard">
                <Row>
                    {map}
                </Row>
            </div>);
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, null)(Dashboard);